import { render } from "./EditFlaggingSearchBtn.vue?vue&type=template&id=0c44940a&ts=true"
import script from "./EditFlaggingSearchBtn.vue?vue&type=script&lang=ts"
export * from "./EditFlaggingSearchBtn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__